import {EventEmitter, Injectable} from "@angular/core";
import {Location} from "@angular/common";

// global settet portal config
declare let advisorPortalConfig: { [key: string]: string; };

/**
 * Service with helper functions for handling portals
 */
@Injectable({
  providedIn: 'root'
})
export class PortalService {
  /**
   * default portal if non is set
   */
  public static readonly defaultPortal = 'co2online';

  /**
   * HOlds the currently active portalId
   */
  public currentPortalId = null;

  /**
   * Eventemitter to be called, if the portal has changed
   */
  public portalHasChanged: EventEmitter<string> = new EventEmitter<string>();

  /**
   * HOlds the global defined portalConfig if there is one
   * @private
   */
  private readonly portalConfig: {[key: string]: string} = {};

  /**
   * constructor
   * @param location
   */
  constructor(private location: Location) {
    try {
      if (window.sessionStorage && window.sessionStorage.getItem('advisor-portalId')) {
        this.currentPortalId = window.sessionStorage.getItem('advisor-portalId');
        this.portalHasChanged.emit(this.currentPortalId);
      }
    }
    catch (e) {}

    // extract the current portalID as first part of the current URL
    const locationPathParts = this.location.path().split('/');
    if(locationPathParts?.length > 0) {
      this.currentPortalId = locationPathParts[1];
      this.portalHasChanged.emit(this.currentPortalId);

      // save to session storage
      try {
        if (window.sessionStorage) {
          window.sessionStorage.setItem('advisor-portalId', this.currentPortalId);
        }
      } catch (e) {

      }
    }

    // try to get portal config
    if(typeof advisorPortalConfig !== "undefined") {
      this.portalConfig = advisorPortalConfig;
    }
  }

  /**
   * get a config parameter in a static way
   * @param parameter
   */
  public static getConfig(parameter: string): string {
    if(typeof advisorPortalConfig !== "undefined" && advisorPortalConfig.hasOwnProperty(parameter)) {
      return advisorPortalConfig[parameter];
    }
    return null;
  }

  /**
   * Returns the value of a certiain portal config perameter. Returns null if the requested parameter is not set.
   * @param parameter
   */
  public getConfig(parameter: string): string {
    if(this.portalConfig.hasOwnProperty(parameter)) {
      return this.portalConfig[parameter];
    }
    return null;
  }

  /**
   * Returns the value of a certiain portal config perameter. Returns false if the requested parameter is not set.
   * @param parameter
   */
  public getConfigAsBool(parameter: string): boolean {
    if (this.portalConfig.hasOwnProperty(parameter)) {
      return parseInt(this.portalConfig[parameter], 10) === 1;
    }
    return false;
  }

  /**
   * returns if the current portal is a inetrnal project
   */
  public isInternalPortal(): boolean {
    return typeof this.portalConfig['embed.internal.portal'] !== "undefined" &&
      parseInt(this.portalConfig['embed.internal.portal'], 10) === 1;
  }
}
